module.exports = __webpack_public_path__ + "img/Mobilleo Wave.92710af4.svg";